import { types } from "./internet.type"

export const updateConnectionStatus = (isConnected) => {
    return {
        type: types.UPDATE_CONNECTION_STATUS,
        isConnected
    }
}